import React from 'react'
import Spin from 'antd/es/spin'
import 'antd/es/spin/style/css'

type SpinProps = {
  size?: 'small' | 'large' | 'default'
}

const MainSpin = ({ size, ...props }: SpinProps) => {
  return <Spin size={size} {...props} />
}
export default MainSpin
